// extracted by css-extract-rspack-plugin
export default {"rating":"ySQhtiqhx0rKUr8U","rating_text":"kG__zIgsownJnuEW","space1":"zorh3eM2eAuNnNhb","s_label_bank":"jK1t6k11RsQDHjbM"};